<template>
  <vf-button
    :aria-label="isFavorite ? $t.removeFromFavorites : $t.favorites"
    :class="brandClasses.button"
    :data-test-id="`product-cta-${isFavorite ? 'remove' : 'add'}-favorites`"
    :disabled
    :loading="pending"
    :size
    :variant="isFavorite && variantSelected ? variantSelected : variant"
    @click="isFavorite ? emit('remove') : emit('add')"
  >
    <vf-icon
      :class="{ [brandClasses.iconSelected]: isFavorite }"
      :name="isFavorite ? 'heart-filled' : 'heart'"
      :size="iconSize"
    />
    <span v-if="!iconOnly" aria-hidden="true" class="ml-2">
      {{ $t.favorites }}
    </span>
  </vf-button>
</template>

<script lang="ts" setup>
const { disabled, isFavorite, pending } = defineProps<{
  disabled?: boolean
  isFavorite?: boolean
  pending?: boolean
}>()

const emit = defineEmits<{
  add: []
  remove: []
}>()

const {
  favorites: { brandClasses, iconOnly, iconSize, variantSelected },
  size,
  variant
} = useAppConfig().components.product.cta
</script>
